module.exports = __webpack_public_path__ + "img/digital-token.bd5348d1.svg";